import { Marker } from 'react-leaflet';
import { useRef } from 'react';
import useZoomLevel from './useZoomLevel'; 
import { CONST_CANTON, CONST_HIGHWAY, FOB } from '../Constants/ConstantsOptics';
import ShowEditingCoorComponent from '../Drawing/ShowEditingCoorComponent';
import { UpdateFobCoordinate } from '../UpdateData/UpdateCommunications';

const MarkersTwoIconViewingFob = ({ data, iconCoupling, iconCouplingCanton,layersVisibilityCommunications,
   isLineDrawing, flag, openModalWithContent, statusModalTerritory, highwayFlag, cantonFlag, showPonLayer, showKtvLayer, showEtherLayer, isComponentChangeCoor,
   setIsComponentChangeCoor, cantonRefresh, highwayRefresh, user, type}) => {

  
  const zoomLevel = useZoomLevel();
  const newCoordinates = useRef({}); 

  

  const handleMarkerDragEnd = (event, id) => {
    if (!isComponentChangeCoor) return; 

    const { lat, lng } = event.target.getLatLng();
    newCoordinates.current = {};
    newCoordinates.current = { id, lat, lng, type };
  };

   const handleSave = () => {
        const { id, lat, lng, type } = newCoordinates.current;
       if(type === FOB) {
        if (statusModalTerritory === CONST_HIGHWAY) {
          UpdateFobCoordinate(id, lat, lng, user, highwayRefresh);
        } else if (statusModalTerritory === CONST_CANTON) {
          UpdateFobCoordinate(id, lat, lng, user, cantonRefresh);
        }
      }else{
        console.log("Не определено ", type);
      }
    
        newCoordinates.current = {};
        setIsComponentChangeCoor(false); 
      };
 
  return (
    <>
      {data.map((item, index) => {
        const eventHandlers = {};
        if (!isLineDrawing && !flag) {
          eventHandlers.click = () => {
            let content = '';
            if (statusModalTerritory === CONST_HIGHWAY) {
              content = highwayFlag;
            } else if (statusModalTerritory === CONST_CANTON) {
              content = cantonFlag;
            }
            openModalWithContent(item, content);
          };
        }

        // Проверяем, если уровень зума равен или больше 13, то не отображаем маркер
        if (zoomLevel <= 15) {
          return null;
        }
       
         // Conditional rendering of markers based on rankComponentId
         const markerIcon = item.rankComponentId === 1 || item.rankComponentId === 2
         ? iconCoupling
         : iconCouplingCanton;

         const shouldDisplayMarker =
         layersVisibilityCommunications &&
         (
           (showPonLayer && item.pon === 1) || 
           (showKtvLayer && item.ktv === 1) || 
           (showEtherLayer && item.ether === 1) ||
           (!showPonLayer && !showKtvLayer && !showEtherLayer && item.nodeStatus !== 1)
         );
       
         if (!shouldDisplayMarker) {
           return null;
         }

         return (
          <Marker
            key={index}
            position={[item.latitude, item.longitude]}
            icon={markerIcon}
            draggable={isComponentChangeCoor}
            eventHandlers={{
              click: eventHandlers.click,
              dragend: (event) => handleMarkerDragEnd(event, item.id),
            }}
          />
        );
      })}
        {/* Компонент для сохранения или отмены изменений */}
        <ShowEditingCoorComponent
          isComponentChangeCoor={isComponentChangeCoor}
          setIsComponentChangeCoor={setIsComponentChangeCoor}
          handleSave={handleSave} 
        />
    </>
  );
}

export default MarkersTwoIconViewingFob;


